import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import {AsaConfig} from "crqlar-react-common/dist/models/integrations/asa/asa.config";
import ImportLogsTable from "../../common/ImportLogsTable";

interface Props {
    configData: UseEntityData<AsaConfig>
}

const Logs = ({configData}: Props) => (
    <ImportLogsTable
        configId={configData.item.id}
        tableId="system-asa-import-logs"
    />
);

export default Logs;
